document.documentElement.classList.remove('no-js');

const modelYears = {
  'model-y': [
    { label: '2025+ Juniper', handle: 'model-y-2025-juniper' },
    { label: '2020–2024', handle: 'model-y-2020-2024' }
  ],
  'model-3': [
    { label: '2024+ Highland', handle: 'model-3-2024-highland' },
    { label: '2017–2023', handle: 'model-3-2017-2023' }
  ],
  'model-s': [
    { label: '2021+ Refresh', handle: 'model-s-2021-refresh' },
    { label: '2012–2020', handle: 'model-s-2012-2020' }
  ],
  'model-x': [
    { label: '2022+ Refresh', handle: 'model-x-2022-refresh' },
    { label: '2015–2021', handle: 'model-x-2015-2021' }
  ]
};

document.querySelectorAll('[data-vehicle-finder]').forEach((form) => {
  const model = form.querySelector('[data-model-select]');
  const generation = form.querySelector('[data-generation-select]');
  const sync = () => {
    generation.innerHTML = modelYears[model.value].map((item) => '<option value="' + item.handle + '">' + item.label + '</option>').join('');
  };
  model.addEventListener('change', sync);
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    window.location.href = '/collections/' + generation.value;
  });
  sync();
});

const toggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
if (toggle && mobileMenu) {
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    mobileMenu.hidden = open;
  });
}

document.querySelectorAll('[data-sort-by]').forEach((select) => {
  const current = new URL(window.location.href);
  select.value = current.searchParams.get('sort_by') || 'manual';
  select.addEventListener('change', () => {
    current.searchParams.set('sort_by', select.value);
    window.location.href = current.toString();
  });
});

// Accessible desktop mega-menu: hover and keyboard open it; outside click and Escape close it.
const desktopDropdowns = [...document.querySelectorAll('.desktop-nav .nav-dropdown')];
const setDropdownState = (dropdown, open) => {
  dropdown.open = open;
  dropdown.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
};
const closeDesktopDropdowns = (except = null) => {
  desktopDropdowns.forEach((dropdown) => {
    if (dropdown !== except) setDropdownState(dropdown, false);
  });
};

desktopDropdowns.forEach((dropdown) => {
  const summary = dropdown.querySelector(':scope > summary');
  if (!summary) return;
  let closeTimer;

  dropdown.addEventListener('mouseenter', () => {
    window.clearTimeout(closeTimer);
    closeDesktopDropdowns(dropdown);
    setDropdownState(dropdown, true);
  });
  dropdown.addEventListener('mouseleave', () => {
    closeTimer = window.setTimeout(() => setDropdownState(dropdown, false), 180);
  });
  dropdown.addEventListener('focusin', () => {
    window.clearTimeout(closeTimer);
    closeDesktopDropdowns(dropdown);
    setDropdownState(dropdown, true);
  });
  dropdown.addEventListener('focusout', (event) => {
    if (!dropdown.contains(event.relatedTarget)) {
      closeTimer = window.setTimeout(() => setDropdownState(dropdown, false), 100);
    }
  });
  summary.addEventListener('click', (event) => {
    event.preventDefault();
    // A mouse click follows mouseenter, so keep that hover-open menu visible.
    // Keyboard activation (where :hover is false) still toggles normally.
    const shouldOpen = dropdown.matches(':hover') ? true : !dropdown.open;
    closeDesktopDropdowns(dropdown);
    setDropdownState(dropdown, shouldOpen);
  });
  dropdown.addEventListener('toggle', () => {
    summary.setAttribute('aria-expanded', String(dropdown.open));
  });
});

document.addEventListener('pointerdown', (event) => {
  if (!event.target.closest('.desktop-nav')) closeDesktopDropdowns();
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const openDropdown = document.querySelector('.desktop-nav .nav-dropdown[open]');
    if (openDropdown) {
      const summary = openDropdown.querySelector(':scope > summary');
      setDropdownState(openDropdown, false);
      summary?.focus();
    }
  }
});

// Keep privacy choices available after the regional Shopify banner is dismissed.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');
  if (!trigger) return;

  event.preventDefault();
  if (window.privacyBanner?.showPreferences) {
    window.privacyBanner.showPreferences();
  }
});
